import { BlazeError } from '@blaze-cms/core-errors';
import { getDynamicMutation } from '../../application';

const createEntityRecord = async (client, entitySchema, input) => {
  const mutation = getDynamicMutation('CREATE_ENTITY_MUTATION')(entitySchema);

  const { data } = await client.mutate({
    mutation,
    variables: { input }
  });

  const result = data?.createdEntity?.result;
  if (!result) {
    throw new BlazeError('Create entity mutation did not return the created record');
  }

  return result;
};

export default createEntityRecord;
